import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetPostCommentsActionType {
  Reset = 'postComments/resetPostComments',
}

export type TResetPostComments = ITypedReduxAction<EResetPostCommentsActionType.Reset>;
